module.exports = __webpack_public_path__ + "img/contactSupport.d78bdcac.png";